import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type UploadAnalyticsCommonParams } from './uploadAnalyticsTypes';
import META from './useTrackUploadCompleted.meta';

export type UseTrackUploadCompletedParams = UploadAnalyticsCommonParams & {
  upload_duration_ms?: number;
  upload_url_type?: 'primary' | 'fallback' | 'mixed';
};

export const useTrackUploadCompleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackUploadCompleted = useCallback(
    (params: UseTrackUploadCompletedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackUploadCompleted };
};
